import React from "react";
import DateRangePicker from "./components/DateRangePicker";

const App: React.FC = () => <DateRangePicker />;

export default App;
